(function () {

    'use strict';

    angular.module('app').controller('AccountingInvoiceDetailsController', AccountingInvoiceDetailsController);

    AccountingInvoiceDetailsController.$inject = [
        '$routeParams',
        'AccountingService',
        'toastr',
        '$location',
        'AccountingInvoiceSurchargesTableService',
        'AccountingInvoiceShipmentsTableService',
        'ConfirmationModalFactory',
        'ViewChangeNotificationFactory',
        '$rootScope'
    ];

    function AccountingInvoiceDetailsController(
        $routeParams,
        AccountingService,
        toastr,
        $location,
        AccountingInvoiceSurchargesTableService,
        AccountingInvoiceShipmentsTableService,
        ConfirmationModalFactory,
        ViewChangeNotificationFactory,
        $rootScope
    ){

        const vm = this;

        const viewConfirmation = new ConfirmationModalFactory({}, {
            message: 'messages.warning.viewChange.MESSAGE',
            code: 'messages.warning.viewChange.CODE',
        });
        const onRouteChange = $rootScope.$on('$routeChangeStart', checkIfThereIsUnsavedData);
        
        vm.id          = $routeParams.id === 'add' ? null : $routeParams.id;
        vm.activeIndex = 0;

        vm.changeTab      = changeTab;
        vm.updateCallback = updateCallback;
        vm.runReconciliation = runReconciliation; 
        vm.importCSV = importCSV;

        init();
        
        function init() {
            loadInvoiceDetails();
        }

        function loadInvoiceDetails(){
            if(vm.id) {
                vm.isFetching = true;
                AccountingService.Invoices.getOne(data => {
                    vm.invoice = data;
                    vm.currency = vm.invoice.currency;
                    vm.invoiceOriginalData = angular.copy(data);
                    
                    // totalSummaryReconcile();
                    // totalSummaryUnreconcile()
                    initUnreconciledShipments();
                    initReconciledShipments();
                    initSurcharges();
                    vm.isFetching = false;
                }, error => {
                    toastr.error('Error', error.message);
                    $location.path('/accounting');
                    vm.isFetching = false;
                }, vm.id);
            }
            else {
                vm.invoice = {};
            }
        }

        function checkIfThereIsUnsavedData(event, next) {
            if(angular.isDefined(vm.invoice) && angular.isDefined(vm.invoiceOriginalData)) {
                let invoiceData         = angular.copy(vm.invoice); 
                let invoiceOriginalData = angular.copy(vm.invoiceOriginalData);
                
                delete invoiceData.shipments; 
                delete invoiceOriginalData.shipments;
            }
        }

        function changeTab(index) {
            if (index === vm.activeIndex || !vm.invoice) {
                return;
            }
            vm.activeIndex = index;
        }

        function initSurcharges() {
            vm.surcharges = new AccountingInvoiceSurchargesTableService( groupSurcharges(vm.invoice.surchargeProfiles)).tableData;
            vm.surcharges.resetFilters();
        }

        function groupSurcharges(surchargeProfiles){
            let surcharges = [];
            surchargeProfiles.forEach(data=>{
                data.surcharges.map(item=>{
                    item.name = data.name;
                    return item;
                });
                surcharges = surcharges.concat(data.surcharges);
            });
            return surcharges
        }

        function initReconciledShipments(){
            vm.reconcilledShipmentsInstance = new AccountingInvoiceShipmentsTableService(vm.id, vm.invoice, vm.invoice.shipments, reloadTableData, true);
            vm.reconcilledShipments = vm.reconcilledShipmentsInstance.tableData;
            vm.reconcilledShipments.resetFilters();
        }

        function initUnreconciledShipments() {
            vm.shipmentTableInstance = new AccountingInvoiceShipmentsTableService(vm.id, vm.invoice, vm.invoice.shipments, reloadTableData, false);
            vm.shipments = vm.shipmentTableInstance.tableData;
            vm.shipments.resetFilters();
        }

        function reloadTableData(){
            initReconciledShipments()
            initUnreconciledShipments()
        }
        
        function runReconciliation(){
            vm.runningReconciliation = true;
            AccountingService.Reconciliations.runReconcillation(success => {
                updateCallback()
                toastr.success("Shipments Reconciliation Complete", "SUCCESS");
                vm.runningReconciliation = false;
            }, error => {
                if (!error.message) {
                    toastr.warning("Invoice has no imported shipments", "WARNING");
                } else {
                    toastr.error("error.message", "ERROR");
                }
                vm.runningReconciliation = false;
            }, [vm.invoice.id]);
        }

        function importCSV(){
            $location.path(`/accounting/invoices/${vm.invoice.id}/import`);
        }

        function updateCallback() {
            vm.shipmentTableInstance.updateTableData();
           // vm.reconcilledShipmentsInstance.updateTableData();
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/accounting/AccountingInvoiceDetailsController.js